
<v-container
    v-if  = "site && current"
    class = "step-container"
>
    <c-drop-message
        v-if     = "drag.notAllowed"
        :message ="drag.message"
    />

    <d-attach-confirm
        v-model = "attach.visible"
        :data   = "attach.data"
        @attach = "onAttach"
        @cancel = "onAttachCancel"
    />

    <drop @drop="onDrop" mode="cut" :accepts-type="onAcceptType">
        <v-row class="no-frame">
            <v-col class="step-first-column" style="border: none; padding: 0;">
                <div class="lm-border pa-3" style="flex: 1">
                    <!-- Status -->
                    <v-row class="no-frame mt-0" >
                        <v-col class="no-frame">
                            <inc-status
                                v-model = "current.status"
                                :items  = "step.status"
                                :label  = "$t('invoice.status')"
                                @change = "onStatusChanged"
                            />
                        </v-col>
                    </v-row>
                    <!-- Status -->

                    <!-- Processing time -->
                    <inc-processing-interval
                        :data       = "data"
                        :status     = "current.status"
                        :background = "collective ? 'field-group-background-blue' : ''"
                    />
                    <!-- Processing time -->

                    <!-- Order - main invoice -->
                    <v-row class="no-frame mt-0" >
                        <v-col class="no-frame mr-2">
                            <v-text-field
                                :label            = "$t('invoice.ordernumber')"
                                v-model           = "data.ordernumber"
                                :background-color = "fileEntryFieldBackground"
                                autocomplete      = "off"
                                autocorrect       = "off"
                                autocapitalize    = "off"
                                spellcheck        = "false"
                            />
                        </v-col>
                    </v-row>
                    <!-- Order - main invoice -->

                    <!-- Description -->
                    <v-row
                        v-if="data.tags.includes('description')"
                        class="no-frame mt-9"
                    >
                        <v-textarea
                            :label            = "$t('invoice.description')"
                            v-model           = "data.description"
                            :background-color = "fileEntryFieldBackground"
                            rows              = "8"
                            autocomplete      = "off"
                            autocorrect       = "off"
                            autocapitalize    = "off"
                            spellcheck        = "false"
                            no-resize
                        />
                    </v-row>
                    <!-- Description -->

                    <v-row
                        v-if  = "index === 0 && complainReasonAllowed"
                        class = "no-frame mt-4"
                        style="display: block;flex:1;"
                    >
                        <v-textarea
                            v-model        = "data.complaintreason"
                            :label         = "$t('invoice.complaintreason')"
                            rows           = "8"
                            autocomplete   = "off"
                            autocorrect    = "off"
                            autocapitalize = "off"
                            spellcheck     = "false"
                            class="pt-0"
                            hide-details
                            no-resize
                        />
                    </v-row>
                </div>
            </v-col>
            <v-col class="step-middle-column" style="border: none; padding: 0">
                <!-- Total account -->
                <p-mixed-invoice-sum
                    :invoice     = "data"
                    :status      = "current.status"
                    :collective  = "collective"
                    class        = "mb-3"
                    @stampmail   = "onSendStampMail"
                    @stamped     = "onStamped"
                />
                <!-- Total account -->

                <!-- Receipients -->
                <p-inc-invoice-recipients
                    usage       = "COSTS"
                    :separated  = "separated"
                    :recipients = "recipients"
                    :data       = "data"
                    :collective = "collective"
                    style       = "flex:1;"
                />

                <!-- Receipients -->
            </v-col>
            <v-col class="step-middle-column" style="max-width: calc(25% - 20px); border: none; padding: 0">
                <!-- Abstract of maintenance contract data -->
                <c-contract-mnt-abstract
                    :show-unit = "collective"
                    class      = "lm-border pa-3 mt-0 mb-3 contract-abstract"
                />
                <!-- Abstract of maintenance contract data -->

                <v-row class = "no-frame lm-border pa-3">
                    <v-col class = "no-frame mt-0 col-12 ">
                        <v-row class="no-frame pr-1" v-if="collective">
                            <v-col class="no-frame">
                                <f-title :title="$t('invoice.sum.maintenance')" />
                            </v-col>
                        </v-row>
                        <v-row class="no-frame pb-2 pr-1" v-if="collective">
                            <v-col class="no-frame pr-2">
                                <f-read-only-field
                                    :label       = "$t('invoice.cost.net')"
                                    :value       = "toMoney (sum.mnt.amount)"
                                    :align-right = "true"
                                    :collective  = "collective"
                                    :filled      = "!collective"
                                    dense
                                />
                            </v-col>
                            <v-col class="no-frame pl-2">
                                <f-read-only-field
                                    :label       = "$t('invoice.cost.correction')"
                                    :value       = "toMoney (sum.mnt.correction)"
                                    :align-right = "true"
                                    :collective  = "collective"
                                    :filled      = "!collective"
                                    dense
                                />
                            </v-col>
                        </v-row>

                        <v-row class="no-frame" :class="collective ? 'mt-10' : ''">
                            <v-col class="no-frame">
                                <f-title :title="getUnitText( $t('invoice.item.maintenance'))" />
                            </v-col>
                        </v-row>
                        <v-row class="no-frame">
                            <v-col class="no-frame pr-2">
                                <p-inc-invoice-amount
                                    :status          = "current"
                                    :item            = "current.item_1"
                                    :amount          = "current.item_1.amount"
                                    :show-costs      = "false"
                                    :form            = "form"
                                    :validate-amount = "true"
                                    :calculation     = "mntCalculation"
                                />
                            </v-col>
                            <v-col class="no-frame pl-2">
                                <p-inc-invoice-amount
                                    :label="$t('invoice.cost.correction')"
                                    :status          = "current"
                                    :item            = "current.item_1"
                                    :amount          = "current.item_1.correction"
                                    :show-costs      = "false"
                                    :form            = "form"
                                    :validate-amount = "false"
                                />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

            </v-col>
            <v-col class="step-last-column" style="border: none; padding: 0">
                <v-row v-if="!notice" class="w-100 no-frame" >
                    <v-col class="no-frame">
                        <c-contract-esc-abstract
                            :show-unit = "collective"
                            class      = "mb-3 contract-abstract"
                        />

                        <v-row class="no-frame lm-border pa-3" style="height: calc(100% - 277px);">
                            <v-col class="no-frame mt-0 col-12 ">
                                <v-row class="no-frame pr-1" v-if="collective">
                                    <v-col class="no-frame">
                                        <f-title :title="$t('invoice.sum.emergency')" />
                                    </v-col>
                                </v-row>
                                <v-row class="no-frame pb-2 pr-1" v-if="collective">
                                    <v-col class="no-frame pr-2">
                                        <f-read-only-field
                                            :label       = "$t('invoice.cost.net')"
                                            :value       = "toMoney (sum.emc.amount)"
                                            :align-right = "true"
                                            :collective  = "collective"
                                            :filled      = "!collective"
                                            dense
                                        />
                                    </v-col>
                                    <v-col class="no-frame pl-2">
                                        <f-read-only-field
                                            :label       = "$t('invoice.cost.correction')"
                                            :value       = "toMoney (sum.emc.correction)"
                                            :align-right = "true"
                                            :collective  = "collective"
                                            :filled      = "!collective"
                                            dense
                                        />
                                    </v-col>
                                </v-row>

                                <v-row class="no-frame" :class="collective ? 'mt-10' : ''">
                                    <v-col class="no-frame">
                                        <f-title :title="getUnitText($t('invoice.item.emergency'))" />
                                    </v-col>
                                </v-row>
                                <v-row class="no-frame">
                                    <v-col class="no-frame pr-2">
                                        <p-inc-invoice-amount
                                            :status          = "current"
                                            :item            = "current.item_2"
                                            :amount          = "current.item_2.amount"
                                            :show-costs      = "false"
                                            :form            = "form"
                                            :validate-amount = "false"
                                        />
                                    </v-col>
                                    <v-col
                                        class="no-frame pl-2"
                                    >
                                        <p-inc-invoice-amount
                                            :label           = "$t('invoice.cost.correction')"
                                            :status          = "current"
                                            :item            = "current.item_2"
                                            :amount          = "current.item_2.correction"
                                            :show-costs      = "false"
                                            :form            = "form"
                                            :validate-amount = "false"
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>
                            <c-v-spacer />
                        </v-row>
                    </v-col>

                </v-row>
                <v-row class="notice-column" v-show="notice">
                    <crm-journal
                        :incident="incident"
                        @front   ="onJournalFront"
                    />
                </v-row>
            </v-col>
        </v-row>
    </drop>
</v-container>
